<template>
  <div
    class="rr-tracker"
    :class="classes"
  >
    <div class="rr-tracker__soon" v-if="disabled" v-html="soonText"></div>
    <div class="rr-tracker__container">
      <div class="rr-tracker__col">
        <div class="rr-tracker__info">
          <div
            class="rr-tracker__icon"
            :style="'background-image: url(' + providerImg + ')'"
          ></div>
          <div class="rr-tracker__name">
            <img v-if="provider === 'strava'" src="./img/strava-only.svg" width="151" alt="">
            <div v-else>
              <span v-html="provider !== 'simplerun' ? providerName : providerName + ' '"></span>
              <span v-if="provider === 'simplerun'" class="rr-tracker__name_limit">(только бег)</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rr-tracker__col" v-if="!disabled">
        <slot></slot>
        <div class="rr-tracker__actions" v-if="!active">
          <div class="rr-tracker__action" v-if="!hideInstruction">
            <Link
              variant="secondary"
              size="sm"
              :href="instructionLink"
              :target="instructionTarget"
              :text="instructionText"
            ></Link>
          </div>
          <div class="rr-tracker__action">
            <Button
              variant="secondary"
              size="sm"
              :text="connectText"
              :loading="loading"
              mobile
              @click.prevent="$emit('connect', providerId)"
            ></Button>
          </div>
        </div>
        <div class="rr-tracker__actions" v-else>
          <div class="rr-tracker__action">
            <Button
              variant="ghost"
              view="danger"
              size="sm"
              :text="disconnectText"
              :loading="loading"
              mobile
              @click.prevent="$emit('disconnect', providerId)"
            ></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import providers from '@rr-component-library/common/src/js/tracker-providers';
import Link from '@rr-component-library/link/src/main';
import Button from '@rr-component-library/button/src/main';

export default {
  name: 'Tracker',
  designVersion: '1.0.0',
  components: {
    Button,
    Link,
  },
  props: {
    /**
     * Id провайдера
     */
    id: String,
    /**
     * Название провайдера
     */
    name: String,
    /**
     * Картинка провайдера
     */
    img: String,
    /**
     * Ссылка на инструкцию
     */
    instructionLink: String,
    /**
     * Атрибут target для ссылки на инструкцию
     */
    instructionTarget: String,
    /**
     * Провайдер.<br>
     * Устанавливает id, name и img для выбранного провайдера
     */
    provider: {
      type: String,
      validator(value) {
        return ['', 'googlefit', 'strava', 'polar', 'garmin', 'fitbit', 'nike', 'runkeeper', 'runtastik', 'suunto', 'simplerun', 'scounttracker'].indexOf(value) !== -1;
      },
    },
    /**
     * Трекер подключён
     */
    active: {
      type: Boolean,
      default: false,
    },
    /**
     * Трекер недоступен
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Скрывает ссылку на инструкцию
     */
    hideInstruction: {
      type: Boolean,
      default: false,
    },
    /**
     * Состояние загрузки
     */
    loading: {
      type: Boolean,
      default: false,
    },
    connectText: {
      type: String,
      default: 'Подключить',
    },
    disconnectText: {
      type: String,
      default: 'Отключить',
    },
    instructionText: {
      type: String,
      default: 'Инструкция',
    },
    soonText: {
      type: String,
      default: 'Скоро',
    },
  },
  computed: {
    classes() {
      return {
        'rr-tracker_active': this.active,
        'rr-tracker_disabled': this.disabled,
      };
    },
    providerData() {
      return this.provider && providers[this.provider];
    },
    providerId() {
      return this.id || this.provider;
    },
    providerImg() {
      return this.img || (this.providerData && this.providerData.img);
    },
    providerName() {
      return this.name || (this.providerData && this.providerData.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Tracker";
</style>
